import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * Labels des cases à cocher d'impression.
 * Pour `oeuvresDescriptionEnsemble` : clé `bo.print.catalogueRaisonneName`
 * via `vt` (plus le nom dynamique du CR — retour client).
 */
export function usePrintSettingFieldLabel() {
  const { t } = useTranslation();
  const vt = useVisibleT();

  return useCallback(
    (field: string) => {
      if (field === "oeuvresDescriptionEnsemble") {
        return vt(
          "bo.print.catalogueRaisonneName",
          "Nom du catalogue raisonné",
        );
      }
      return t(field);
    },
    [t, vt],
  );
}
